export default {
  data() {
    return {
      resizeHandler: null,
    };
  },
  mounted() {
    this.resizeHandler = this.$store.watch(
      (state) => state.responsive,
      () => {
        this.handleResize();
      },
      { 
        deep: true,
        immediate: true
      },
    );
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    if (this.resizeHandler) {
      this.resizeHandler();
    }
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      const newWidth = window.innerWidth;
      let viewDesktopLists = this.$store.state.responsive.viewDesktopLists;
      let viewDesktopFilters = this.$store.state.responsive.viewDesktopFilters;
      let viewDesktopSpecial = this.$store.state.responsive.viewDesktopSpecial;
      if (newWidth > 1465) {
        viewDesktopSpecial = true;
      } else {
        viewDesktopSpecial = false;
      }
      if (newWidth > 1280) {
        viewDesktopLists = true;
      } else {
        viewDesktopLists = false;
      }
      if (newWidth > 991) {
        viewDesktopFilters = true;
      } else {
        viewDesktopFilters = false;
      }
      const resultFinal = {
        viewDesktopLists,
        viewDesktopFilters,
        viewDesktopSpecial,
      }
      if (
          (viewDesktopLists !== this.$store.state.responsive.viewDesktopLists) 
          || (viewDesktopFilters !== this.$store.state.responsive.viewDesktopFilters)
          || (viewDesktopSpecial !== this.$store.state.responsive.viewDesktopSpecial)
        ) {
          this.$store.commit("setViewResponsive", resultFinal);
      }
    },
  },
};